import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=2588f3c4&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=ts"
export * from "./ProductEdit.vue?vue&type=script&lang=ts"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=2588f3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588f3c4",
  null
  
)

export default component.exports